/**
 * Item Editor Component
 * Inline editor for extracted menu items
 */

import { Check, X } from 'lucide-react';
import React, { useState } from 'react';
import { ExtractedItem } from '../../../../types/menu';

interface ItemEditorProps {
  item: ExtractedItem;
  onSave: (item: ExtractedItem) => void;
  onCancel: () => void;
}

export const ItemEditor: React.FC<ItemEditorProps> = ({
  item,
  onSave,
  onCancel,
}) => {
  const [editedItem, setEditedItem] = useState<ExtractedItem>({ ...item });

  return (
    <div className="bg-white rounded-lg p-3 border border-pos-primary shadow-sm space-y-2">
      <input
        type="text"
        value={editedItem.item_name}
        onChange={(e) =>
          setEditedItem({ ...editedItem, item_name: e.target.value })
        }
        className="w-full px-2 py-1 text-sm border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-pos-primary"
        placeholder="Item name"
      />
      <div className="flex gap-2">
        <input
          type="number"
          value={editedItem.base_price}
          onChange={(e) =>
            setEditedItem({
              ...editedItem,
              base_price: parseFloat(e.target.value) || 0,
            })
          }
          className="w-24 px-2 py-1 text-sm border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-pos-primary"
          placeholder="Price"
          step="0.01"
        />
        <input
          type="text"
          value={editedItem.department}
          onChange={(e) =>
            setEditedItem({ ...editedItem, department: e.target.value })
          }
          className="flex-1 px-2 py-1 text-sm border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-pos-primary"
          placeholder="Department"
        />
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="p-1 text-gray-400 hover:text-gray-600"
        >
          <X size={16} />
        </button>
        <button
          type="button"
          onClick={() => onSave(editedItem)}
          className="p-1 text-pos-primary hover:text-pos-secondary"
        >
          <Check size={16} />
        </button>
      </div>
    </div>
  );
};
